import { post } from '@/common/request';
import { useEffect, useState } from 'react';

function useCategoryType(resourcesType: 0 | 1, visible?: boolean, disabled = false) {
  const [data, setData] = useState<any>([]);


  useEffect(() => {
    const getCategorys = async () => {
      // 直接调数据资源中心接口
      // https://yapi.lanhanba.com/project/399/interface/api/51197
      const data = await post('/tenant/category/list', { resourcesType }, { needCancel: false, proxyApi: '/resserv' });
      const newData = data.map(item => {
        const { parentId } = item;
        return {
          ...item,
          disabled: resourcesType === 0 && disabled && parentId === null
        };
      });
      setData(newData);
    };

    if (visible === undefined || visible) {
      getCategorys();
    }

  }, [resourcesType, visible]);

  return data;
}

export default useCategoryType;
